<script>
  import { getAccessibilityRedesignRenderState } from '../../../../../js/stores';
  // Props
  export let isOpen = false;
  export let flyoutOffsetLeft = 0;

  const accessibilityRedesignRenderStore = getAccessibilityRedesignRenderState();
</script>

<!-- 
  NOTE:
  To ensure that the flyout is visibily hidden until the css is ready, 
  we use --flyout-visibility variable with hidden as default to toggle visibility
-->
<div
  class="FlyoutFlattened"
  class:isOpen
  class:flyout-flattened-animation={!$accessibilityRedesignRenderStore}
  class:flyout-flattened-accessibility-redesign={$accessibilityRedesignRenderStore}
  style="visibility: var(--flyout-visibility, hidden); --flyout-offset-left: {flyoutOffsetLeft}px;"
>
  <slot />
</div>

<style>.FlyoutFlattened {
  border-width: 0;
  border-style: solid;
  color: var(--color-text, #1a1a1a);
  background-color: var(--color-background, #fff);
  border-color: var(--color-border, #d9d9d9);
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  position: absolute;
  overflow: hidden;
  top: 100%;
  left: calc(var(--flyout-offset-left) * -1);
  border-radius: 4px;
  border-width: 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
  --flyout-visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transform: translate3d(0, -10px, 0);
}

.flyout-flattened-animation {
  transition: visibility 0ms 100ms, pointer-events 0ms, opacity 100ms cubic-bezier(0.4, 0, 1, 1), transform 100ms cubic-bezier(0.4, 0, 1, 1), width 250ms cubic-bezier(0.4, 0, 0.2, 1);
}
.flyout-flattened-animation.isOpen {
  transition: visibility 0ms, pointer-events 0ms 150ms, opacity 150ms cubic-bezier(0, 0, 0.2, 1), transform 150ms cubic-bezier(0, 0, 0.2, 1), width 250ms cubic-bezier(0.4, 0, 0.2, 1);
}

.flyout-flattened-accessibility-redesign {
  box-shadow: none;
  border-radius: 0;
}

.isOpen {
  --flyout-visibility: visible;
  opacity: 1;
  pointer-events: auto;
  transform: translate3d(0, 0, 0);
}</style>
